import { FEATURE_FLAGS_RECEIVED } from '../actions/GetFeatureFlags';

const initialState = {
};

const featureFlags = (state = initialState, action) => {
  switch(action.type) {
    case FEATURE_FLAGS_RECEIVED:
      return {
        ...action.featureFlags,
      };
  }

  return state;
};

export default featureFlags;
